<div
  class="color-panel-overlay"
  [style.top.px]="position.top"
  [style.left.px]="position.left"
  (click)="onBackdropClick()"
>
  <div
    class="color-panel-content"
    (click)="$event.stopPropagation()"
  >
    @for (row of allColors; track $index) {
      <div class="color-row">
        @for (color of row; track $index) {
          <button
            class="color-box"
            [style.background-color]="color"
            (click)="setColor(color)"
          ></button>
        }
      </div>
    }
    <div class="color-text">Другой</div>
    <label class="edit-color-label">
      <input
        type="color"
        class="edit-color"
        [required]="required"
        (change)="handleInputEvent($event)"
        (blur)="handleValueChange(value)">
    </label>
  </div>
</div>
